<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title"></div>
      <router-link class="btn-blue" to="refund"
        >{{ $tc("refund", 1) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <div class="section-title mb-4">
        {{ $t("show") }} {{ $t("transaction") }}
      </div>
      <div class="swc-report">
        <h5>
          {{ $tc("Schedule Delete", 1) }} {{ $tc("reason", 1) }} :-
          {{ refund_reason.scd_reason }}
        </h5>

        <div class="d-flex justify-content-between align-item-center mb-3">
          <!-- <button
            :disabled="enable"
            @click.prevent.stop="OpenModal()"
            class="btn-blue float-right mw-auto"
          >
            Refund All
          </button>
          <button
            :disabled="enable"
            v-if="selected_refund.length == 0"
            @click.prevent.stop="changestatus"
            class="btn-blue float-right mw-auto"
          >
            Refund Individual
          </button> -->
          <!-- <button
            v-else
            @click.prevent.stop="onAddRefund('Individual')"
            class="btn-blue"
          >
            {{ $t("done") }}
          </button> -->
        </div>
        <div class="table-scroll">
          <table class="swc-report-table w-100" border="1">
            <thead class>
              <tr class="bg-lightgrey">
                <th colspan="2">{{ $t("transaction") }} {{ $t("number") }}</th>
                <th>{{ $tc("booking", 1) }} {{ $tc("date", 1) }}</th>
                <th>{{ $tc("film", 1) }} {{ $t("name") }}</th>
                <th>{{ $t("show") }} {{ $tc("date", 1) }}</th>
                <th>{{ $t("show") }} {{ $tc("time", 1) }}</th>
                <th>{{ $tc("screen", 1) }} {{ $tc("name", 1) }}</th>
                <th>{{ $tc("seat", 1) }} {{ $tc("number", 1) }}</th>
                <th>{{ $tc("total", 1) }} {{ $t("amount") }}</th>
                <th>{{ $tc("refund", 1) }} {{ $t("amount") }}</th>
                <!-- <th>{{ $tc('refund',1) }} {{ $tc('reason',1) }}</th> -->
                <th>{{ $tc("payment", 1) }} {{ $tc("mode", 1) }}</th>
                <th>{{ $t("Customer Name") }}</th>
                <th>{{ $t("Customer Email") }}</th>
                <th>{{ $t("Mobile No") }}</th>
                <th>{{ $t("Is Guest User") }}</th>
                <th>{{ $t("Refund Reason") }}</th>
                <th>{{ $t("Refund Date Time") }}</th>
                <th>{{ $t("Create") }} {{ $tc("refund", 1) }}</th>
              </tr>
            </thead>
            <tbody
              v-if="getTransactionRefundstData.length > 0"
              class="sph-report"
            >
              <tr
                v-for="(transaction,
                transactionIndex) in getTransactionRefundstData"
                :key="transactionIndex"
              >
                <td colspan="2">{{ transaction.sb_booking_code }}</td>
                <td>{{ transaction.t_booking_date_time | fulldateparse }}</td>
                <td>{{ transaction.film_name }}</td>
                <td>{{ transaction.t_show_date | dateparse }}</td>
                <td>{{ transaction.t_show_time }}</td>
                <td>{{ transaction.screen_name }}</td>
                <td>{{ transaction.seats }}</td>
                <td>{{ transaction.t_gross_amount }}</td>
                <td>{{ transaction.total_refund_amount | RoundOff }}</td>
                <!-- <td>{{ transaction.rr_reason || "-" }}</td> -->
                <td>{{ transaction.pm_payment_mode || "-" }}</td>
                <td>{{ transaction.customer_name || "-" }}</td>
                <td>{{ transaction.cust_email || "-" }}</td>
                <td>{{ transaction.customer_mobile || "-" }}</td>
                <td>{{ transaction.is_guest_user || "-" }}</td>
                <td>{{ transaction.rr_reason || "-" }}</td>
                <td>{{ transaction.t_refund_date_time | fulldateparse }}</td>

                <td
                  v-if="
                    transaction.total_refund_amount <= 0 &&
                      transaction.payment_mode_id != 1
                  "
                >
                  <b-form-checkbox
                    v-if="refundindi"
                    class="j-checkbox"
                    :value="transaction"
                    v-model="selected_refund"
                  />
                  <b-button
                    v-else
                    variant="default"
                    :to="`/cinema-manager/make-a-refund?booking_id=${transaction.sb_booking_code}`"
                    class="btn-blue v-step-1"
                  >
                    {{ $tc("refund") }}
                  </b-button>
                </td>
                <td
                  v-else-if="
                    transaction.payment_mode_id == 1 &&
                      transaction.total_refund_amount <= 0
                  "
                >
                  <button
                    v-on:click="gotoRoute()"
                    class="btn-blue mw-auto mr-3"
                  >
                    Make A Refund
                  </button>
                </td>
                <td v-else>Refund Proceeded</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="13">No Record Found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal id="confirmation" title="Confirm" hide-footer no-close-on-backdrop>
      <label class="h4 mt-2 mb-4 text-center"
        >Are you sure you want to Refund All Transactions ?</label
      >
      <br />
      <div class="text-center">
        <button class="btn-blue" @click.prevent.stop="onAddRefund('All')">
          Yes
        </button>
        <button
          class="btn-blue text-right"
          @click.prevent.stop="hideModal('confirmation')"
        >
          No
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import { mapState, mapGetters, mapActions } from "vuex";
import RefundService from "@/services/RefundService";
import PosService from "@/services/PosService";
export default {
  components: { DatePicker },
  data() {
    return {
      enable: false,
      rr_id: "",
      refund_reason: "",
      refundindi: false,
      selected_refund: [],
      id: "",
      getTransactionRefundstData: []
    };
  },
  computed: {
    ...mapGetters([])
  },
  beforeMount() {
    const { id } = this.$route.query;
    this.id = id;
    this.rr_id = this.$route.query.rr_id;
    if (id) {
      this.getShowTransactions(id);
    }
  },
  mounted() {},
  methods: {
    changestatus: function() {
      this.refundindi = true;
    },
    OpenModal: function() {
      this.$bvModal.show("confirmation");
    },
    hideModal: function(modal) {
      if (modal == "confirmation") {
        this.$bvModal.hide("confirmation");
      }
    },
    gotoRoute: function() {
      this.$router.push({
        path: "/cinema-manager/make-a-refund"
      });
    },
    getShowTransactions(id) {
      RefundService.GetShowTransaction({ ss_id: id })
        .then(response => {
          const { data } = response;
          if (data.status) {
            // data.Records.forEach(record => {
            //   if (String(record.t_refund_date_time).toLowerCase().includes('invalid')) {
            //     record.t_refund_date_time = ''
            //   }
            // })

            this.getTransactionRefundstData = data.Records;

            if (this.getTransactionRefundstData.length == 0) {
              this.enable = true;
            } else {
              this.refund_reason = data.Records[0];
              this.enable = false;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          this.$toasted.show("Something went wrong!");
        });
    },
    onAddRefund: function(type) {
      let payload;
      if (type == "All") {
        this.$bvModal.hide("confirmation");

        let filterdata = this.getTransactionRefundstData.filter(
          x => x.payment_mode_id != 1 && x.total_refund_amount.length <= 0
        );

        if (filterdata && filterdata.length > 0) {
          payload = {
            RefundList: filterdata
          };
        } else {
          this.$toasted.show(
            'Please Click on "Make A Refund" for Payment modes "Cash"'
          );
          return;
        }
      }
      if (type == "Individual") {
        payload = {
          RefundList: this.selected_refund
        };
      }
      // payload = {
      //   ssb_id: transaction.ssb_ids,
      //   sb_id: transaction.sb_id,
      //   booking_id: null,
      //   enterRefundAmount:
      //     transaction.t_gross_amount / transaction.seats_array.length,
      //   //
      //   booking_status_id: null,
      //   rr_reason: null,
      //   rr_id: this.rr_id,
      //   payment_mode_id: transaction.payment_mode_id,
      //   //
      //   curr_code: null,
      //   sb_total_net_amount: null,
      //   sb_total_amount: null,
      //   sb_total_amount_paid: null
      // };
      // console.log("payload.enterRefundAmount :", payload.enterRefundAmount);
      PosService.updateRefunds(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            const { id } = this.$route.query;
            if (id) {
            this.getShowTransactions(id);
            }

            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/RefundComponents/showTransactions.vue